var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-menu-item',{attrs:{"index":_vm.data.route}},[_c('span',{class:{active_color: _vm.data.route === _vm.activeIndex}}),_c('i',{class:_vm.iconClass}),_c('span',{class:{active: _vm.data.route === _vm.activeIndex},attrs:{"slot":"title"},slot:"title"},[_vm._v("\n      "+_vm._s(_vm.data.name)+"\n    ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }